module.exports = __webpack_public_path__ + "media/assets/icons/thought-bubble-4ee3602a7cf5ed3106260f4a727a867f.svg";